import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Dropdown } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface LayoutModeSelectProps {
  onLayoutChange: (layout: API_USERDATA_LAYOUTTYPE) => void;
  currentLayout: string;
}

export const LayoutModeSelect = ({ onLayoutChange, currentLayout }: LayoutModeSelectProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  const handleClick = ({ key }) => {
    onLayoutChange(key as API_USERDATA_LAYOUTTYPE);
  };

  return (
    <Dropdown
      menu={{
        items: [
          { key: "LIST", label: t("List") },
          { key: "SPLIT", label: t("Split") },
        ],
        selectedKeys: [currentLayout],
        onClick: handleClick,
      }}
      trigger={["click"]}
    >
      <div className="pointer">
        <FontAwesomeIcon style={{ fontSize: 22 }} icon={["far", "bars"]} fixedWidth={true} />
        <FontAwesomeIcon fixedWidth={true} icon={["fas", "sort-down"]} transform="up-2" />
      </div>
    </Dropdown>
  );
};
